// extracted by mini-css-extract-plugin
module.exports = {"container":"motion-breadcrumb_container__YAjCA"};